import React from "react";
import { ReactPopover } from "../pages/album/wizard/Tracks/ReactPopover";
import { Button } from "./Button";
import { faArrowsSpin, faFileText } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useFilePicker } from "use-file-picker";
import { useLoading } from "../hooks/use-loading";
import { useMusicApi } from "../api/useMusicApi";
import { toast } from "react-toastify";
import { AxiosError } from "axios";

type Props = {
  isCompact?: boolean;
};
export const UploadLyricsButton: React.FC<Props> = ({ isCompact }) => {
  const { t } = useTranslation();
  const { postUploadLyricsFile } = useMusicApi();
  const { loadings, startLoading, stopLoading } = useLoading({
    upload: false
  });

  const [open] = useFilePicker({
    accept: [".xlsx"],
    multiple: false,
    onFilesSuccessfulySelected: async (data) => {
      try {
        startLoading("upload");
        await postUploadLyricsFile(data.plainFiles[0]);
        toast.success(t("upload_lyrics_success"));
      } catch (e) {
        const validationError =
          ((e as AxiosError).response?.data as any)?.errors ?? [];
        toast.error(validationError[0]?.detail ?? t("something_went_wrong"));
      } finally {
        stopLoading("upload");
      }
    }
  });

  return (
    <>
      <ReactPopover
        trigger={"hover"}
        className={"w-5/6"}
        direction={isCompact ? "right" : "top"}
        content={
          <div
            style={{ display: "inline-block" }}
            className={
              "w-full text-muted font-normal flex justify-between text-xs"
            }
          >
            <div>{t("upload_lyrics_description")}</div>
          </div>
        }
      >
        {isCompact ? (
          <Button
            onClick={open}
            className={"bg-blue-500 px-0 py-0 w-9 h-9 text-white hover:bg-blue-400 rounded-3xl border-none"}
            iconSpin={loadings.upload}
            icon={loadings.upload ? faArrowsSpin : faFileText}
          />
        ) : (
          <Button
            loading={loadings.upload}
            label={t("add_lyrics_button").toString()}
            onClick={open}
            className={"w-full text-white border hover:bg-gray-700 rounded-lg"}
          />
        )}
      </ReactPopover>
    </>
  );
};
